/* 🔴 W119 — ONE GRAMMAR FOR EVERY HOVER-ACTION ROW (William, 2026-10-01 ~00:40: *"maybe just the preview and assign as text
 * buttons … and the edit, copy and delete just icon buttons? so a pencil, a copy icon and a trash can?"*; Fable: his third
 * option). What GOES somewhere or does the row's main thing is a WORD; the edit-class actions are ICONS. Which is which is
 * decided HERE, by the action's kind, so the four surfaces (the Workouts list, the Clients roster, the Exercises shelf, the
 * client Week card) can never draw one action two ways. */

export type StripIcon = "pencil" | "copy" | "trash";

/** One action in a strip: a link (`href`) or a button (`onClick`), its word, and its kind (`key`), which decides its icon. */
export type StripItem = {
  readonly key: string;
  readonly label: string;
  readonly href?: string;
  readonly onClick?: () => void;
  readonly disabled?: boolean;
  readonly destructive?: boolean;
};

const ICON: Readonly<Record<string, StripIcon>> = {
  edit: "pencil",
  copy: "copy",
  duplicate: "copy",
  delete: "trash",
  remove: "trash",
};

/** The icon an action of this kind wears, or null — a word. */
export function stripIcon(kind: string): StripIcon | null {
  return ICON[kind] ?? null;
}

/* 🔴 JOB 3 STEP 5 PAGE 4 (Fable's brief, 2026-10-09; `docs/brand/JOB3-INVENTORY.md` §3 item 4: "Copy / Delete / Hide into
 * the ⋯, two actions visible") — A ROW DRAWS ITS TASK'S OWN ACTION ON HOVER AND EVERYTHING ELSE IN ONE `⋯`. The row's list
 * stays ONE list (W108): this splits it, it never re-orders or re-words it, so the strip and the menu can never offer
 * different things or one thing twice. `onRow` names the keys the strip keeps; the rest go to the ⋯ in the list's order. */
export function splitRow<T extends { readonly key: string }>(items: readonly T[], onRow: readonly string[]): {
  readonly strip: readonly T[];
  readonly more: readonly T[];
} {
  return {
    strip: items.filter((it) => onRow.includes(it.key)),
    more: items.filter((it) => !onRow.includes(it.key)),
  };
}
